export const H2H = 1;
export const TICKET_CHALLENGE = 2;
export const TARGET_CHALLENGE = 3;
